import { SyntheticEvent, useState } from 'react';
import {
  AccordionDetails,
  AccordionSummary,
  useMediaQuery,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

import { FooterAccordion } from '../CustomAccordion/CustomAccordion';

import TouchAppIcon from '@mui/icons-material/TouchApp';

// import styles from './styles.module.css';

function Footer() {
  const isMobile = useMediaQuery('(max-width: 650px)');
  const location = useLocation();

  // Expandido por defecto
  const [expanded, setExpanded] = useState<string | boolean>(false);

  const textLg ='Como con todo programa fitness, consulta con tu médico y sigue todas las instrucciones de seguridad antes de comenzar cualquier programa de ejercicios o utilizar cualquier suplemento, plan de nutrición o producto de reemplazo de comidas, especialmente si estás embarazada, en período de lactancia o si tienes alguna condición médica particular o especial. El contenido de nuestro sitio web es únicamente informativo y no tiene la intención de diagnosticar ninguna condición médica, reemplazar el consejo de un profesional de la salud ni proporcionar ningún dispositivo, diagnóstico o tratamiento médico. Alumnos/as del Fit4challenge NO están cubiertos por la garantía de resultados, bajo ningún motivo.';

  const copiarTexto = (texto: string) => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(texto)
        .then((res) => {
          toast.success('Texto copiado');
          console.log(res);
        })
        .catch(console.log);
    }
  };
  


  const handleChange = (panel: string) => (_event: SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  if (location.pathname === '/login') return null;
  if (location.pathname !== '/') return null;

  return (
    <div className={`${isMobile ? `h-[156px] ${expanded === 'panelfooter1' ? 'pb-[450px]' : 'overflow-visible'}`  : 'h-[100px]'}`}>
      <div className="w-full flex flex-col justify-center items-center">
        <div className="container flex flex-col items-center text-center mt-8">
          {/* Enlaces */}
          <div className="flex gap-4 mb-1">
            <a
              href="https://tr4iner.com/terminos-y-condiciones/"
              target="_blank"
              className="text-black no-underline cursor-pointer"
              rel="noopener noreferrer"
            >
              Términos
            </a>
            <a
              href="https://tr4iner.com/politica-de-privacidad/"
              target="_blank"
              className="text-black no-underline cursor-pointer"
              rel="noopener noreferrer"
            >
              Privacidad
            </a>
            <a
              href="mailto:clientes@club.tr4iner.com"
              target="_blank"
              className="text-black no-underline cursor-pointer"
              rel="noopener noreferrer"
            >
              Contacto
            </a>
          </div>

          {/* Acordeón */}
          {location.pathname === '/' && (          
            <FooterAccordion
              // className="w-fit"
              expanded={expanded === 'panelfooter1'}
              onChange={handleChange('panelfooter1')}
            >
              <AccordionSummary
                aria-controls="panelfooter1-content"
                className="flex justify-center items-center text-xs text-gray-500 cursor-pointer text-[0.65rem] h-[15px]"
              >
                <p className={`w-full m-0 ${expanded !== 'panelfooter1' ? 'pb-[15px]' : ''}`}>{expanded === 'panelfooter1' ? 'Leer Menos' : 'Leer Más'} 
                  <TouchAppIcon fontSize="small" />
                </p>
              </AccordionSummary>

              <AccordionDetails className="flex justify-center text-center text-xs text-gray-500 mt-2 text-[0.65rem]">
                <div className="max-w-[90%] sm:max-w-[600px] md:max-w-[800px]" onClick={() => copiarTexto(textLg)}>
                  {textLg}
                </div>
              </AccordionDetails>
            </FooterAccordion>
          )}
        </div>
      </div>
    </div>
  );
}

export default Footer;
